import { HorizontalContainer } from '@american-autonomy/ag-ui';

import BoundingBoxLabelTriangleIcon from 'components/icons/BoundingBoxLabelTriangleIcon';

import type { Props } from './types';

import styles from './styles.module.scss';

const BoundingBoxLabelMarker = ({ isActive, isSelected, text }: Props) => {
    const activeContainerStyle = isActive ? styles.activeContainer : '';

    return (
        <div className={`${styles.boundingBoxLabelMarker} ${activeContainerStyle}`}>
            <HorizontalContainer className={styles.textContainer}>
                <div className={styles.text}>{text}</div>

                {isActive && (
                    <BoundingBoxLabelTriangleIcon className={styles.boundingBoxLabelTriangleIcon} />
                )}

                {isSelected && <span className={styles.dotContainer}>{'・'}</span>}
            </HorizontalContainer>
        </div>
    );
};

export default BoundingBoxLabelMarker;
